import * as constants from './constants'

export const get = username => ({
  type: constants.GET_USER.ACTION,
  payload: { username }
})

export const getUserJobTitle = () => ({
  type: constants.GET_USER_JOB_TITLE.ACTION
})
